/* ==========================================================================
   PN BLOG — makale sayfası dergi katmanı            (PN 2.27 · 29.08.2026)
   --------------------------------------------------------------------------
   Modeldeki dört parça, sunum katmanı olarak:
     1. Okuma süresi          — gövdedeki kelime sayısından
     2. "Bu yazıda" içindekiler — gövdedeki h2 başlıklarından
     3. Bağlam içi ürün kartı  — yazıdaki İLK ürün bağlantısını yukarı taşır
     4. Devam bölümü başlığı   — "<Kategori>'dan devam" olarak yeniden yazar

   HİÇBİR VERİ YAZILMAZ. Makale içeriği değişmez; yalnızca sayfaya zaten
   basılmış olan içerik tarayıcıda yeniden düzenlenir. Bu dosya silindiğinde
   makale sayfası eski hâline birebir döner.

   Her adım kendi başına korumalıdır: biri çalışmazsa diğerleri etkilenmez.
   ========================================================================== */
(function () {
  'use strict';

  var WPM = 200; // dakikada okunan ortalama kelime

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* Gövdeyi bul: <article> içinde en çok h2 barındıran kap. */
  function findContent() {
    var scope = document.querySelector('article') || document.body;
    var cands = scope.querySelectorAll(
      '.rte, [class*="article-template__content"], [class*="article__content"]'
    );
    var best = null, most = 0;
    for (var i = 0; i < cands.length; i++) {
      var n = cands[i].querySelectorAll(':scope > h2').length;
      if (n > most) { most = n; best = cands[i]; }
    }
    return best;
  }

  function slug(s) {
    return 'pn-' + s.toLowerCase()
      .replace(/[ıİ]/g, 'i').replace(/[şŞ]/g, 's').replace(/[çÇ]/g, 'c')
      .replace(/[ğĞ]/g, 'g').replace(/[üÜ]/g, 'u').replace(/[öÖ]/g, 'o')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  }

  /* --- 1 · Okuma süresi ------------------------------------------------- */
  function readingTime(content) {
    var words = (content.textContent || '').trim().split(/\s+/).length;
    var min = Math.max(1, Math.round(words / WPM));
    var host = document.querySelector('.pn-article-meta');
    if (!host) {
      // Kategori rozetinin yanına bir meta satırı kur.
      var cat = document.querySelector('.template-article .pn-cat');
      if (!cat || !cat.parentNode) return;
      host = document.createElement('span');
      host.className = 'pn-article-meta';
      cat.parentNode.insertBefore(host, cat.nextSibling);
    }
    host.textContent = min + ' dk okuma';
  }

  /* --- 2 · İçindekiler --------------------------------------------------- */
  function buildToc(content) {
    var heads = content.querySelectorAll(':scope > h2');
    if (heads.length < 3) return; // kısa yazıda içindekiler gürültü olur

    var box = document.createElement('nav');
    box.className = 'pn-toc';
    box.setAttribute('aria-label', 'Bu yazıda');

    var label = document.createElement('div');
    label.className = 'pn-toc__label';
    label.textContent = 'Bu yazıda';
    box.appendChild(label);

    var list = document.createElement('ol');
    list.className = 'pn-toc__list';

    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      var text = (h.textContent || '').trim();
      if (!text) continue;
      if (!h.id) h.id = slug(text) + '-' + i;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    }
    box.appendChild(list);
    content.insertBefore(box, content.firstChild);
  }

  /* --- 3 · Bağlam içi ürün kartı ----------------------------------------
     Denetim bulgusu: ürün bağlantılarının %83'ü yazının son beşte birinde.
     İlk ürün bağlantısını alıp yazının başına okunabilir bir kart olarak
     taşıyoruz. Orijinal bağlantı yerinde kalır — hiçbir şey silinmez. */
  function productCard(content) {
    var link = content.querySelector('a[href*="/products/"]');
    if (!link) return;

    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    var anchorEl = content.querySelector(':scope > h2');
    if (!anchorEl) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.title) return;

        var card = document.createElement('a');
        card.className = 'pn-inline-product';
        card.href = '/products/' + handle;

        var label = document.createElement('span');
        label.className = 'pn-inline-product__label';
        label.textContent = 'Bu yazıda geçen ürün';

        var row = document.createElement('span');
        row.className = 'pn-inline-product__row';

        if (p.featured_image) {
          var img = document.createElement('img');
          img.className = 'pn-inline-product__img';
          img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
          img.alt = '';
          img.loading = 'lazy';
          img.width = 68; img.height = 68;
          row.appendChild(img);
        }

        var body = document.createElement('span');
        body.className = 'pn-inline-product__body';

        var t = document.createElement('span');
        t.className = 'pn-inline-product__title';
        t.textContent = p.title;
        body.appendChild(t);

        if (typeof p.price === 'number' && window.shopSettings) {
          var pr = document.createElement('span');
          pr.className = 'pn-inline-product__price';
          pr.textContent = (p.price / 100).toLocaleString('tr-TR', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
          }) + ' TL';
          body.appendChild(pr);
        }

        row.appendChild(body);
        card.appendChild(label);
        card.appendChild(row);
        anchorEl.parentNode.insertBefore(card, anchorEl);
      })
      .catch(function () { /* sessizce geç — kart olmadan da sayfa tam */ });
  }

  /* --- 4 · Devam bölümü başlığı ------------------------------------------ */
  function relabelRelated() {
    var cat = document.querySelector('.template-article .pn-cat');
    if (!cat) return;
    var name = (cat.textContent || '').trim();
    if (!name) return;

    // Makale gövdesinden SONRA gelen, kart taşıyan ilk bölümü bul.
    var art = document.querySelector('article');
    var secs = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      if (art && s.contains(art)) continue;
      if (!s.querySelector('.article-card')) continue;
      var h = s.querySelector('h2, h3, .title');
      if (h) {
        h.textContent = name + " kategorisinden devam";
        h.classList.add('pn-related-title');
      }
      var more = document.createElement('a');
      more.className = 'pn-related-more';
      more.href = '/blogs/blog/tagged/' + (cat.getAttribute('href') || '').split('/tagged/')[1];
      more.textContent = 'Tüm ' + name + ' yazıları';
      if (more.href.indexOf('undefined') === -1) s.appendChild(more);
      break;
    }
  }

  ready(function () {
    try {
      if (!document.body.classList.contains('template-article')) return;
      var content = findContent();
      if (!content) return;
      readingTime(content);
      buildToc(content);
      productCard(content);
      relabelRelated();
    } catch (e) {
      if (window.console && console.warn) console.warn('[pn-blog]', e);
    }
  });
})();
